import { ProductSubDepartmentListPage } from "@/features/product-sub-department/pages/ProductSubDepartmentListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-sub-department/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_sub_department.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductSubDepartmentListPage,
});
